import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

interface useDragDropProps {
  onFilesSelected: (files: File[]) => void;
}

const acceptedFileTypes = [
  "application/pdf",
  "application/zip",
  "image/jpeg",
  "image/png",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const maxFiles = 20;
const _2MB = 2000000;

function useDragDrop({ onFilesSelected }: useDragDropProps) {
  const intl = useIntl();
  const [files, setFiles] = useState<File[]>([]);
  const [overFileField, setOverFileField] = useState(false);
  const [invalidFormat, setInvalidFormat] = useState<string>("");
  const [invalidSize, setInvalidSize] = useState<string>("");
  const [filesNumber, setNumberFiles] = useState(0);

  const handleFileChange = (event: any) => {
    const selectedFiles = event.target.files as File[];
    if (selectedFiles && selectedFiles.length > 0) {
      validateFiles(selectedFiles);
    }
  };
  const handleDrop = (event: any) => {
    setOverFileField(false);
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files as File[];
    if (droppedFiles && droppedFiles.length > 0) {
      validateFiles(droppedFiles);
    }
  };

  const validateFiles = (chosenFiles: File[]) => {
    let filesTemp = [];
    setInvalidFormat("");
    setInvalidSize("");
    for (const item of chosenFiles) {
      const invalidType = !acceptedFileTypes.includes(item.type);
      const invalidSize = item.size > _2MB;

      if (invalidType) {
        setInvalidFormat((items) =>
          items.length > 0 ? `${items}, ${item.name}` : item.name
        );
      }

      if (invalidSize) {
        setInvalidSize((items) =>
          items.length > 0 ? `${items}, ${item.name}` : item.name
        );
      }

      if (!invalidType && !invalidSize) {
        filesTemp.push(item);
      }
    }

    const newFiles = Array.from(filesTemp);
    const currentLength = files.length;
    const missingLength = maxFiles - currentLength;

    if (files.length < maxFiles) {
      const newArray =
        missingLength > 0
          ? newFiles.slice(0, missingLength)
          : newFiles.slice(0, maxFiles);

      setFiles((prevFiles) => [...prevFiles, ...newArray]);
    }

    setNumberFiles(files.length + newFiles.length);
  };

  const handleRemoveFile = (index: number) => {
    setInvalidFormat("");
    setInvalidSize("");
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    onFilesSelected(files);
  }, [files, onFilesSelected]);

  return {
    handleRemoveFile,
    intl,
    overFileField,
    invalidFormat,
    invalidSize,
    handleFileChange,
    handleDrop,
    setOverFileField,
    files,
    filesNumber,
  };
}

export default useDragDrop;
